import { forwardRef, type Ref, type SVGProps } from "react";
const IconCopyFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m6.975 27.941 3 .013V30H7.034a2.06 2.06 0 0 1-2.059-2.059V25h2.012Z" />
    <path d="M15.975 27.979V30h-4v-2.038z" />
    <path d="m20.916 28 .059-2h2v1.941A2.06 2.06 0 0 1 20.916 30h-2.941v-2.012Z" />
    <path d="M4.975 12.059A2.06 2.06 0 0 1 7.034 10h1.941v2H7.034l-.013 3H4.975Z" />
    <path d="m7.013 17-.017 6H4.975v-6z" />
    <path d="M13.084 2h13.782a2.11 2.11 0 0 1 2.109 2.109v17.783A2.11 2.11 0 0 1 26.867 24H13.084a2.11 2.11 0 0 1-2.108-2.108V4.109A2.11 2.11 0 0 1 13.084 2" />
  </svg>
);
const ForwardRef = forwardRef(IconCopyFilledSVG);
ForwardRef.displayName = "IconCopyFilled";
export { ForwardRef as IconCopyFilled };
